import React from 'react';
import '../styles/LegalPages.css';

function TermsOfService() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Terms of Service</h1>
        <p className="legal-updated">Last updated: November 12, 2025</p>

        <section className="legal-section">
          <h2>Agreement to Terms</h2>
          <p>
            By accessing or using Certifiable, you agree to be bound by these Terms of Service. If you disagree with any part of these terms, you may not access the service. Certifiable is currently a free beta service provided for testing and feedback purposes.
          </p>
        </section>

        <section className="legal-section">
          <h2>Description of Service</h2>
          <p>
            Certifiable is a certificate management application that allows users to store, track, and share professional certifications and credentials. The service includes features such as expiry reminders, file storage, and email sharing capabilities.
          </p>
        </section>

        <section className="legal-section">
          <h2>User Accounts</h2>
          <h3>Account Creation</h3>
          <p>
            To use Certifiable, you must create an account. You agree to provide accurate, current, and complete information during registration and to update such information to keep it accurate, current, and complete.
          </p>

          <h3>Account Security</h3>
          <p>
            You are responsible for safeguarding your account password and for any activities or actions under your account. You must notify us immediately of any unauthorized use of your account.
          </p>

          <h3>Account Termination</h3>
          <p>
            You may delete your account at any time. We reserve the right to suspend or terminate your account if you violate these Terms or for any other reason at our discretion.
          </p>
        </section>

        <section className="legal-section">
          <h2>User Content</h2>
          <h3>Your Responsibilities</h3>
          <p>
            You retain all rights to the certificates and data you upload ("User Content"). You are solely responsible for the accuracy and legality of your User Content.
          </p>

          <h3>License to Us</h3>
          <p>
            By uploading User Content, you grant us a limited license to store, display, and transmit your content solely for the purpose of providing the Certifiable service.
          </p>

          <h3>Prohibited Content</h3>
          <p>You agree not to upload content that:</p>
          <ul>
            <li>Is illegal, fraudulent, or deceptive</li>
            <li>Infringes on intellectual property rights</li>
            <li>Contains malware or viruses</li>
            <li>Violates any applicable laws or regulations</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>Acceptable Use</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Use the service for any illegal purpose</li>
            <li>Attempt to gain unauthorized access to our systems</li>
            <li>Interfere with or disrupt the service</li>
            <li>Upload false or fraudulent certificates</li>
            <li>Share your account credentials with others</li>
            <li>Use automated systems to access the service</li>
            <li>Resell or redistribute the service</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>Beta Service</h2>
          <p>
            Certifiable is currently in beta testing and is provided free of charge for testing and feedback purposes. The service is provided "as is" and may contain bugs or errors. We may modify, suspend, or discontinue any aspect of the service at any time during the beta period.
          </p>
          <p>
            This is a non-commercial project. We do not currently accept payments, charge subscriptions, or generate revenue from this service.
          </p>
        </section>

        <section className="legal-section">
          <h2>Intellectual Property</h2>
          <p>
            The Certifiable service, including its original content, features, and functionality, is operated as a personal project and is protected by international copyright, trademark, and other intellectual property laws.
          </p>
        </section>

        <section className="legal-section">
          <h2>Disclaimer of Warranties</h2>
          <p>
            THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED. WE DO NOT WARRANT THAT THE SERVICE WILL BE UNINTERRUPTED, SECURE, OR ERROR-FREE.
          </p>
          <p>
            We are not responsible for verifying the authenticity or validity of certificates you upload. You are responsible for ensuring your certificates are genuine and current.
          </p>
        </section>

        <section className="legal-section">
          <h2>Limitation of Liability</h2>
          <p>
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, THE OPERATOR OF CERTIFIABLE SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, WHETHER INCURRED DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES.
          </p>
          <p>
            We are not responsible for any consequences resulting from expired certificates, missed reminders, or inability to access your data. This is a beta testing service provided without warranty.
          </p>
        </section>

        <section className="legal-section">
          <h2>Indemnification</h2>
          <p>
            You agree to indemnify and hold harmless the operator of Certifiable from any claims, damages, or expenses arising from your use of the service, your violation of these Terms, or your violation of any rights of another party.
          </p>
        </section>

        <section className="legal-section">
          <h2>Data Backup</h2>
          <p>
            While we implement backup procedures, you are responsible for maintaining your own backups of important certificates. We recommend keeping original copies of your certificates in a separate location.
          </p>
        </section>

        <section className="legal-section">
          <h2>Changes to Terms</h2>
          <p>
            We reserve the right to modify these Terms at any time. We will notify users of significant changes via email or through the application. Your continued use of the service after changes constitutes acceptance of the new Terms.
          </p>
        </section>

        <section className="legal-section">
          <h2>Governing Law</h2>
          <p>
            These Terms shall be governed by and construed in accordance with the laws of Sweden, without regard to its conflict of law provisions.
          </p>
        </section>

        <section className="legal-section">
          <h2>Contact Us</h2>
          <p>
            If you have any questions about these Terms, please contact us at:
          </p>
          <p>
            Email: <a href="mailto:romijade@gmail.com">romijade@gmail.com</a>
          </p>
          <p>
            Certifiable is a personal project operated by an independent developer based in Sweden.
          </p>
        </section>

        <div className="legal-footer">
          <a href="/">← Back to Home</a>
        </div>
      </div>
    </div>
  );
}

export default TermsOfService;
